var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.99,33.83c-0.58,4.16-2.67,6.15-6.8,6.46c-6.31,0.47-16.33,0.34-29.02,0.18l-3.74-0.05 c-1.01-0.01-2.12-0.15-3.19-0.4c-2.88-0.68-4.58-2.47-5.05-5.29c-0.85-5.24-0.91-11.28-0.17-16.56c0.57-4.15,2.67-6.14,6.79-6.46 c3.24-0.25,6.98-0.33,12.11-0.33c4.54,0,10.17,0.07,17.52,0.16l3.13,0.04c1.06,0.01,2.16,0.15,3.19,0.39 c2.89,0.69,4.59,2.47,5.05,5.3C50.66,22.49,50.72,28.52,49.99,33.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.99,11c-1.1-0.26-2.28-0.4-3.41-0.42l-3.13-0.04c-15.69-0.2-23.57-0.29-29.72,0.18 c-4.56,0.34-7.08,2.74-7.71,7.32C0.27,23.41,0.33,29.56,1.2,34.89c0.54,3.26,2.49,5.32,5.8,6.11c1.16,0.27,2.31,0.41,3.41,0.42 l3.74,0.05c6.11,0.08,11.61,0.15,16.37,0.15c5.15,0,9.44-0.08,12.74-0.33c4.56-0.34,7.08-2.74,7.71-7.33 c0.76-5.48,0.69-11.46-0.18-16.85C50.26,13.85,48.31,11.79,44.99,11z M49.98,33.83c-0.57,4.16-2.67,6.15-6.8,6.47 c-6.31,0.47-16.33,0.34-29.02,0.18l-3.74-0.05c-1.01-0.01-2.12-0.15-3.19-0.4c-2.89-0.69-4.58-2.47-5.05-5.3 c-0.85-5.24-0.92-11.27-0.18-16.56c0.57-4.15,2.67-6.14,6.8-6.46c3.24-0.25,6.97-0.34,12.1-0.34c4.54,0,10.17,0.07,17.52,0.16 l3.12,0.04c1.06,0.02,2.17,0.16,3.2,0.4c2.89,0.69,4.58,2.47,5.05,5.3C50.65,22.49,50.72,28.52,49.98,33.83z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 26,
    cy: 26,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 26,
    cy: 26,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 31.5,
    cy: 21,
    r: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayid);
export default __webpack_public_path__ + "static/media/payid.3786ae027095ad7560039c6dd8975344.svg";
export { ForwardRef as ReactComponent };